import { render, staticRenderFns } from "./FundingProjectContractCard.vue?vue&type=template&id=da1635c0&"
import script from "./FundingProjectContractCard.vue?vue&type=script&lang=js&"
export * from "./FundingProjectContractCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports